/**
 * Bryter. Innhold har fyll, ikke kant — ogsaa her.
 *
 * Portert ordrett fra `apps/mobile/src/components/Switch.tsx`. Stilen ligger
 * i global.css og bruker `--tc-wash-strong`, som maatte legges til paa
 * nettflata for dette.
 */
export function Switch({
  value, onChange, label, disabled = false,
}: {
  value: boolean;
  onChange(): void;
  label: string;
  disabled?: boolean;
}): JSX.Element {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      aria-label={label}
      disabled={disabled}
      onClick={onChange}
      className={`switch${value ? " switch--on" : ""}${disabled ? " switch--disabled" : ""}`}
    >
      <span className="switch__knob" />
    </button>
  );
}
